<template>
  <div>
    <generic-container
      :title="$t('accounts')"
      icon="file invoice dollar"
      :show_plus="true"
      :configurable="true"
      v-bind:configure_modal="configure_modal"
      v-on:add="add"
    >
      <table
        class="ui blue very compact celled striped selectable table"
        ref="table"
        style="width:100%"
      >
        <thead>
          <tr>
            <th>{{ $t("type") }}</th>
            <th>{{ $t("number") }}</th>
            <th>{{ $t("name") }}</th>
          </tr>
        </thead>
        <tbody></tbody>
      </table>
    </generic-container>
    <template v-for="(mdl, index) in account_modals">
      <component :is="mdl" :key="index" v-on:destroy="destroy" v-on:succedded="succedded"></component>
    </template>
  </div>
</template>

<script>
import filters from "@/filters";
import { init_ajax_data_datables } from "@/utils";
import GenericContainer from "@/components/GenericContainer";
import ConfigureModal from "./configuration_modal/Index.vue";
import AccountModal from "./AccountModal";

// @ is an alias to /src
export default {
  name: "AccountIndex",
  components: {
    "generic-container": GenericContainer
  },
  filters: filters,
  data() {
    return {
      accounts: [],
      configure_modal: ConfigureModal,
      account_modals: []
    };
  },
  methods: {
    add() {
      this.account_modals.push(AccountModal);
    },
    succedded(account) {
      let trgtIdx = this.accounts.findIndex(n => n.uuid == account.uuid);
      if (trgtIdx == -1) {
        this.accounts.push(account);
      } else {
        this.accounts.splice(trgtIdx, 1, account);
      }
    },
    destroy() {
      // this.account_modals = [];
      // this.customer = {};
    },
    show_account(account) {
      this.$router.push({
        name: "AccountsView",
        query: { i: account.uuid }
      });
    }
  },
  created() {},
  mounted() {
    let vm = this;

    let columns = [
      {
        data: function(row) {
          return row.acc_type.name;
        }
      },
      {
        data: function(row) {
          return row.number;
        }
      },
      {
        data: function(row) {
          return row.name;
        }
      }
    ];

    let onSelect = data => {
      vm.show_account(data);
    };

    init_ajax_data_datables(
      vm,
      vm.$refs.table,
      window.jQuery.fn.api.settings.api["account url"],
      columns,
      onSelect
    );

    // let dict = "//cdn.datatables.net/plug-ins/1.10.21/i18n/English.json";
    // if (vm.$i18n.locale == "es")
    //   dict = "//cdn.datatables.net/plug-ins/1.10.21/i18n/Spanish.json";
    // else if (vm.$i18n.locale == "fr")
    //   dict = "//cdn.datatables.net/plug-ins/1.10.21/i18n/French.json";

    // window.jQuery(vm.$refs.table).DataTable({
    //   processing: true,
    //   serverSide: true,
    //   pageLength: 10,
    //   language: {
    //     url: dict
    //   },
    //   ajax: {
    //     url: window.jQuery.fn.api.settings.api["account url"],
    //     type: "post",
    //     beforeSend: function(request) {
    //       let token = vm.$session.get("token");
    //       if (token) {
    //         request.setRequestHeader("x-access-token", token);
    //       }
    //     },
    //     dataSrc: function(json) {
    //       if (!json.success) vm.$alertify.error(json.error);
    //       else return json.data;
    //     }
    //   },
    //   columns: [
    //     {
    //       data: function(row) {
    //         return row.acc_type.name;
    //       }
    //     },
    //     {
    //       data: function(row) {
    //         return row.number;
    //       }
    //     },
    //     {
    //       data: function(row) {
    //         return row.name;
    //       }
    //     },
    //   ],
    //   createdRow: function(row, data) {
    //     window.jQuery(row).click(function() {
    //       vm.show_account(data);
    //     });
    //   }
    // });
  },
  watch: {}
};
</script>
